import ForgePage from "./ForgePage";

export default ForgePage;